import React from 'react';

function ColorSelector(props) {
    return (
        <input
            type="color"
            value={props.value}
            onChange={props.onChange}
            style={{ width: '35px', height:'35px', verticalAlign: 'middle', marginRight:'10px'}} // Basic styling for the picker
        />
    );
}

export default ColorSelector;